export enum AuthLoginResponseType {
  OTP = 'otp',
  SUCCESS = 'success'
}
